import { render } from "./EnrollmentBoostBlog.vue?vue&type=template&id=2f81962a&scoped=true"
import script from "./EnrollmentBoostBlog.vue?vue&type=script&lang=js"
export * from "./EnrollmentBoostBlog.vue?vue&type=script&lang=js"

import "./EnrollmentBoostBlog.vue?vue&type=style&index=0&id=2f81962a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f81962a"]])

export default __exports__